import { getAuth } from '@/libs/v1/api/client';
import Store from '@/store';

function updateAuth(auth: any) {
  Store.commit('updateAuth', auth);
}

export async function loadAuth() {
  try {
    const auth = await getAuth();
    updateAuth(auth);
  } catch (e) {
    updateAuth(null);
    throw e;
  }
}
